import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="year-range"
export default class extends Controller {
  static targets = ["minRange", "maxRange", "minDisplay", "maxDisplay", "fill"]
  static values = { min: Number, max: Number }

  connect() {
    this.updateFill()
    this.updatePositions()
  }

  update(event) {
    let minVal = parseInt(this.minRangeTarget.value)
    let maxVal = parseInt(this.maxRangeTarget.value)

    if (minVal > maxVal) {
      if (event.target === this.minRangeTarget) {
        this.minRangeTarget.value = maxVal
        minVal = maxVal
      } else {
        this.maxRangeTarget.value = minVal
        maxVal = minVal
      }
    }

    this.minDisplayTarget.value = minVal
    this.maxDisplayTarget.value = maxVal
    this.updateFill()
    this.updatePositions()
  }

  updateFromInput() {
    let minVal = parseInt(this.minDisplayTarget.value) || this.minValue
    let maxVal = parseInt(this.maxDisplayTarget.value) || this.maxValue

    minVal = Math.max(this.minValue, Math.min(minVal, maxVal))
    maxVal = Math.min(this.maxValue, Math.max(maxVal, minVal))

    this.minRangeTarget.value = minVal
    this.maxRangeTarget.value = maxVal
    this.minDisplayTarget.value = minVal
    this.maxDisplayTarget.value = maxVal
    this.updateFill()
    this.updatePositions()
  }

  updateFill() {
    const min = parseInt(this.minRangeTarget.value)
    const max = parseInt(this.maxRangeTarget.value)
    const total = this.maxValue - this.minValue

    const leftPercent = ((min - this.minValue) / total) * 100
    const widthPercent = ((max - min) / total) * 100

    this.fillTarget.style.left = leftPercent + "%"
    this.fillTarget.style.width = widthPercent + "%"
  }

  // Position each input box so its centre sits directly below its thumb.
  // Range thumbs don't travel the full track width — they're inset by one
  // thumb-radius (8px) at each end, so we account for that offset.
  updatePositions() {
    const trackWidth = this.minRangeTarget.offsetWidth
    if (!trackWidth) return

    const thumbRadius = 8
    const travelWidth = trackWidth - thumbRadius * 2
    const total = this.maxValue - this.minValue

    const minVal = parseInt(this.minRangeTarget.value)
    const maxVal = parseInt(this.maxRangeTarget.value)

    const minPx = thumbRadius + ((minVal - this.minValue) / total) * travelWidth
    const maxPx = thumbRadius + ((maxVal - this.minValue) / total) * travelWidth

    this.minDisplayTarget.style.left = minPx + "px"
    this.maxDisplayTarget.style.left = maxPx + "px"
  }
}
